module.exports = __webpack_public_path__ + "static/img/qr-code.45d3bb97.jpg";